import {getPrivateAxios} from '../../libs';

export interface DeleteTeamMemberDto {
  teamId: string;
  userId: string;
}

export const fetchTeamMemberDelete = async ({teamId, userId}: DeleteTeamMemberDto) => {
  return getPrivateAxios()
    .delete(`/teams/${teamId}/members/${userId}`)
    .then((r) => r.data);
};
